var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "merchant"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b mdmax:shadow-none mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Tambah Merchant",
      "url": "/merchant/create",
      "linkType": "internal",
      "size": _vm.isMobile ? 'full' : 'regular'
    }
  })], 1)]), _vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex gap-2"
        }, [!entry.is_upgraded ? _c('Button', {
          attrs: {
            "buttonText": "Upgrade",
            "type": "primary",
            "size": "small"
          },
          on: {
            "action": function ($event) {
              return _vm.upgrade(entry.id);
            }
          }
        }) : _vm._e(), _c('span', {
          staticClass: "flex items-center gap-2"
        }, [_c('Toggle', {
          attrs: {
            "value": !!entry.is_active_api,
            "id": `merchant-onoff-${entry.id}`
          },
          on: {
            "input": function ($event) {
              return _vm.toggleOnOff(entry, $event);
            }
          }
        }), _c('span', {
          staticClass: "text-xs font-semibold text-neutral-600"
        }, [_vm._v(" " + _vm._s(entry.is_active_api ? "On" : "Off") + " ")])], 1), _c('LinkButton', {
          attrs: {
            "buttonText": "Lihat rincian",
            "url": `/merchant/detail/${entry.id}`,
            "linkType": "internal",
            "type": "secondary",
            "size": "small"
          }
        })], 1) : column.field === 'id' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(entry[column.field]) + " ")]) : column.field === 'sender_name' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(entry.merchant_place.sender_name) + " ")]) : column.field === 'phone_number' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(entry.merchant_place.phone_number) + " ")]) : column.field === 'is_upgraded' ? _c('span', {
          staticClass: "block"
        }, [_c('span', {
          staticClass: "inline-block px-2 py-1 rounded text-xs whitespace-nowrap w-full text-center font-extrabold",
          class: {
            'bg-green-100 text-green-700': entry[column.field],
            'bg-gray-100 text-gray-700': !entry[column.field]
          }
        }, [_vm._v(" " + _vm._s(entry[column.field] ? "VIP" : "Non-VIP") + " ")])]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }